import type { Command } from "@/lib/commands/types";

// Navigation commands map 1:1 to the top-level sidebar entries.
// Each owns a single-digit hotkey under "mod"; sticking to ⌘1..⌘9
// gives muscle memory parity with editors and Linear.
export const commandsNav: Command[] = [
  {
    id: "nav.dashboard",
    label: "Go to Dashboard",
    group: "navigation",
    scope: "global",
    hotkey: { mod: ["mod"], key: "1" },
    handler: { kind: "navigate", href: "/dashboard" },
    keywords: ["home", "overview", "exceptions"],
  },
  {
    id: "nav.loads",
    label: "Go to Loads",
    group: "navigation",
    scope: "global",
    permission: "org:loads:read",
    hotkey: { mod: ["mod"], key: "2" },
    handler: { kind: "navigate", href: "/loads" },
    keywords: ["trips", "deliveries"],
  },
  {
    id: "nav.fleet",
    label: "Go to Fleet (Drivers)",
    group: "navigation",
    scope: "global",
    permission: "org:drivers:read",
    hotkey: { mod: ["mod"], key: "3" },
    handler: { kind: "navigate", href: "/fleet/drivers" },
    keywords: ["drivers", "couriers"],
  },
  {
    id: "nav.customers",
    label: "Go to Customers",
    group: "navigation",
    scope: "global",
    permission: "org:customers:read",
    hotkey: { mod: ["mod"], key: "4" },
    handler: { kind: "navigate", href: "/customers" },
    keywords: ["accounts", "contractors"],
  },
  {
    id: "nav.workflows",
    label: "Go to Workflows",
    group: "navigation",
    scope: "global",
    hotkey: { mod: ["mod"], key: "5" },
    handler: { kind: "navigate", href: "/workflows" },
    keywords: ["rules", "predicates"],
  },
  {
    id: "nav.strategies",
    label: "Go to Strategies",
    group: "navigation",
    scope: "global",
    hotkey: { mod: ["mod"], key: "6" },
    handler: { kind: "navigate", href: "/strategies" },
    keywords: ["dispatch", "scoring"],
  },
  {
    id: "nav.orders",
    label: "Go to Orders",
    group: "navigation",
    scope: "global",
    permission: "org:orders:read",
    handler: { kind: "navigate", href: "/orders" },
    keywords: ["intake"],
  },
  {
    id: "nav.pricing",
    label: "Go to Pricing",
    group: "navigation",
    scope: "global",
    permission: "org:pricing:read",
    featureFlag: "feature_dynamic_pricing",
    handler: { kind: "navigate", href: "/pricing" },
  },
  {
    id: "nav.payouts",
    label: "Go to Payouts",
    group: "navigation",
    scope: "global",
    permission: "org:payouts:read",
    featureFlag: "feature_contractor_payouts",
    handler: { kind: "navigate", href: "/payouts" },
  },
  {
    id: "nav.billing",
    label: "Go to Billing",
    group: "navigation",
    scope: "global",
    permission: "org:billing:read",
    featureFlag: "feature_customer_billing",
    handler: { kind: "navigate", href: "/billing" },
  },
  {
    id: "nav.shortcuts",
    label: "Show Keyboard Shortcuts",
    group: "navigation",
    scope: "global",
    handler: { kind: "navigate", href: "/keyboard-shortcuts" },
    keywords: ["help", "?", "cheatsheet"],
  },
];
